import type { GroupDTO, MemberDTO } from "../../domain/dto/MemberGroupDTO";
import type { Group, Member } from "../../domain/entities/Member";

export const mapGroupDTO = (dto: GroupDTO): Group => ({
  id: dto.id,
  name: dto.name,
  description: dto.description,
  member_count: dto.member_count,
  created_at: dto.created_at,
});
export const mapGroupsDTO = (dtos: GroupDTO[]): Group[] =>
  dtos.map(mapGroupDTO);

const capitalizeStatus = (status?: string): Member["status"] => {
  if (!status) return "Invited";
  const s = status.toLowerCase();
  if (s === "active") return "Active";
  if (s === "inactive") return "Inactive";
  return "Invited";
};

const resolveRoleName = (dto: MemberDTO): string => {
  if (dto.role_name?.trim()) return dto.role_name.trim();
  if (typeof dto.role === "string" && dto.role.trim()) return dto.role.trim();
  if (dto.role && typeof dto.role === "object" && dto.role.name?.trim()) {
    return dto.role.name.trim();
  }
  return "";
};

const resolveRoleId = (dto: MemberDTO): string => {
  if (dto.role_id) return dto.role_id;
  if (dto.role && typeof dto.role === "object" && dto.role.id) {
    return dto.role.id;
  }
  return "";
};

export const mapMemberDTO = (dto: MemberDTO): Member => ({
  id: dto.user_id,
  name: dto.name,
  email: dto.email,
  phone: dto.phone ?? "",
  role: resolveRoleName(dto),
  role_id: resolveRoleId(dto),
  designation_id: dto.designation_id ?? "",
  status: capitalizeStatus(dto.status),
  createdAt: dto.created_at
    ? new Date(dto.created_at).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
    : "",
});

export const mapMembersDTO = (dtos: MemberDTO[]): Member[] =>
  dtos.map(mapMemberDTO);
